const { darken, lighten } = require("polished");

// Used so hover colors get automatically updated
const brandPrimaryColor = "#78BE20";
const brandSecondaryColor = "#E43A36";
const brandTertiaryColor = "#FFD522";
const brandBlackColor = "#101820";

const colors = {
    // Base colors
    "brand-primary": brandPrimaryColor,
    "brand-secondary": brandSecondaryColor,
    "brand-tertiary": brandTertiaryColor,
    "brand-success": "#2DB200",
    "brand-danger": "#E30613",
    "brand-warning": "#F49C10",
    "brand-info": "#0697E3",
    "brand-pale-danger": "#FED7D7",
    "brand-white": "#FFFFFF",
    "brand-light-grey": "#F0F0F0",
    "brand-grey": "#DDDDDD",
    "brand-dark-grey": "#888B8D",
    "brand-black": brandBlackColor,

    // Hover colors
    "brand-primary-lighten": lighten(0.05, brandPrimaryColor),
    "brand-primary-darken": "#5C9219",

    "brand-secondary-lighten": lighten(0.05, brandSecondaryColor),
    "brand-secondary-darken": darken(0.05, brandSecondaryColor),

    "brand-black-lighten": lighten(0.05, brandBlackColor),
    "brand-black-darken": "#213142",
};

const fonts = {
    heading: ["Quicksand, sans-serif"],
    body: ["Quicksand, sans-serif"],
};

module.exports = { colors, fonts };
